<div *ngIf="settingData && checkIDState === 1">
  <div id="donatebackground" >
    <img src="{{settingData.img1}}" id="background">
  </div>
  <div id="donate-screen">
    <section id="main">
      <div id="inner">
        <div class="logo">
          <img src="{{settingData.img2}}" id="logo">
          <p id="introduce">{{introduce}}</p>
        </div>
        <div class="headicon">
          <img src="{{settingData.img3}}" id="headicon">
        </div>
        <section id="one" class="wrapper style1">
          <form action={{opeyUrl}} id="formNextStep" method="post" id="formsend">
            <div class="sponsor-data">
              <dl class="spd-box sb-platform">
                <dd>
                  <mat-form-field style="width: 80%;">
                    <mat-label>你的名字</mat-label>
                    <input matInput type="text" [(ngModel)]="name" name="DonateNickName">
                    <mat-hint align="start">Leave blank to be Anonymous</mat-hint>
                  </mat-form-field>
                </dd>
              </dl>
              <dl class="spd-box sb-price">
                <dd>
                  <mat-form-field class="example-form-field">
                    <mat-label>想要贊助實況主多少錢</mat-label>
                    <input matInput type="number" (input)="endTime()" [(ngModel)]="donate" name="DonateAmount" id="donateAmount">
                    <mat-icon matSuffix svgIcon="custom-svg:angular"></mat-icon>
                    <mat-hint align="start">Minimum: {{settingData.min_money}}$</mat-hint>
                  </mat-form-field>
                  <mat-form-field appearance="fill" id="currency">
                    <mat-label>幣種</mat-label>
                    <mat-select>
                      <mat-option value="TWD">新臺幣</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <p class="red">◎ 如贊助金額低於27元則無法使用超商代碼付款</p>
                </dd>
              </dl>
              <dl class="spd-box sb-msg">
                <dd>
                  <mat-form-field style="width: 100%;">
                    <mat-label>贊助訊息</mat-label>
                    <textarea [(ngModel)]="msg" matInput #msglength cdkTextareaAutosize cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5" name="DonateMsg" id="donatemsg"></textarea>
                    <mat-hint align="end">{{msglength.value.length}} / 100</mat-hint>
                  </mat-form-field>
                </dd>
              </dl>
              <dl class="spd-box sb-msg" id="sendyt">
                <dd>
                  <mat-form-field style="width: 70%;">
                    <mat-label>Youtube影片網址</mat-label>
                    <textarea [(ngModel)]="yt" matInput #test cdkTextareaAutosize cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="5" (keyup)="onkeyupYT($event)" name="yt"></textarea>
                    <mat-hint align="start">分享Youtube影片到實況</mat-hint>
                    <!-- <mat-hint align="end" *ngIf="settingData.youtubeRestrictionLevel > 0" id="ytqualify">瀏覽數需大於{{youtubeRestrictionData.viewCountRestriction}}，好評率需大於{{youtubeRestrictionData.goodRateRestriction*100}}%</mat-hint> -->
                  </mat-form-field>
                </dd>
              </dl>
              <dl>
                <dd>
                  <div>
                    <mat-form-field *ngIf="!yid" appearance="none" id="starttime1">
                      <input matInput type="text" disabled id="starttime">
                      <mat-hint>開始時間(秒)</mat-hint>
                    </mat-form-field>
                    <mat-form-field *ngIf="yid" appearance="none" id="starttime1">
                      <input matInput placeholder="秒數" type="number" (input)="endTime()" id="starttime" min=0 name="starttime" [(ngModel)]="startTime">
                      <mat-hint>開始時間(秒)</mat-hint>
                    </mat-form-field>


                    <mat-form-field appearance="none" id="endtime1">
                      <input matInput type="text" disabled id="endtime" value="{{endtime}}">
                      <mat-hint>結束時間(秒)</mat-hint>
                    </mat-form-field>
                  </div>
                </dd>
              </dl>
            </div>
            <button id="sendbtn" type="submit" (click)="send()" mat-raised-button color="primary">前往歐付寶付款</button>
            <br>
            <div id="email">
              <mat-icon id="emailicon">email</mat-icon>
              <span>: support@hibiki-rain.com</span>
            </div>
          </form>

          <footer>
            <div class="copyright">
              <a> Copyright &copy; Sonic Rain Interactive Entertainment Co., Ltd. All rights reserved.</a>
            </div>
          </footer>
        </section>
      </div>
    </section>
  </div>
